/** @format */
"use client";
import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Flex,
  Avatar,
  Button,
  DropdownMenu,
} from "@radix-ui/themes";
import { CaretDownIcon } from "@radix-ui/react-icons";
import { CountryList, DEFAULT_COUNTRY_CODE } from "@/app/config/constants";
import { Country } from "../services/modelService";

interface CountryProps {
  selectedCountryCode: string;
  handleSelection: any;
  isEnable: boolean;
  isFilter: boolean;
}

const CountryCodeView: React.FC<CountryProps> = (props) => {
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

  useEffect(() => {
    setSelectedCountry(
      CountryList.find(
        (country: Country) =>
          country.code === (props.selectedCountryCode || DEFAULT_COUNTRY_CODE)
      ) || null
    );
  }, [props.selectedCountryCode]);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={
          "!gap-0" +
          (props && !props.isEnable
            ? " !cursor-default !bg-stone-100"
            : " cursor-pointer")
        }
        disabled={props && !props.isEnable}
      >
        <Box className=" rounded-md !border border-secondary-100 h-[40px] flex items-center">
          <Button
            className="hover:cursor-pointer h-[50px] "
            disabled={props && !props.isEnable}
            aria-label={`Select country code, currently ${selectedCountry?.name || 'none selected'}`}
            role="button"
          >
            <Flex direction={"row"} gap="2">
              <Avatar
                className="!max-w-8 !h-8 !min-w-8 flag-style"
                src={(selectedCountry && selectedCountry.flag) || undefined}
                radius="small"
                fallback="T"
              />
              <Text className="text-sm">
                {props && props.isFilter
                  ? `${selectedCountry?.code}(${selectedCountry?.name})`
                  : selectedCountry && selectedCountry.code}
              </Text>
            </Flex>
            <CaretDownIcon />
          </Button>
        </Box>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="!p-4">
        {(props && props.isFilter
          ? [{ name: "All", flag: null, code: null }, ...CountryList]
          : CountryList
        ).map((country: any, index: number) => (
          <DropdownMenu.Item
            key={"country" + index}
            onClick={() => {
              setSelectedCountry(country);
              props.handleSelection(country);
            }}
            className="hover:cursor-pointer hover:bg-primary-default hover:text-white mx-2.5"
            aria-label={`Select ${country.name || 'All countries'}`}
            role="menuitem"
          >
            <Flex
              direction={"row"}
              gap="2"
              justify={"start"}
              className="items-center hover:!text-primary-medium mx-2"
            >
              <Avatar
                className="!w-8 !h-5 flag-style"
                src={country.flag}
                radius="small"
                fallback="T"
              />
              <Text className="text-sm">
                {props && props.isFilter
                  ? `${country?.code}(${country?.name})`
                  : country && country.code}
              </Text>
            </Flex>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default CountryCodeView;
